import { component } from "picoapp";

const TAB_BUTTON_SELECTOR = "button[role='tab']";
export const TAB_SELECTED = "tab-selected";

export const tabs = component((node: HTMLElement) => {
  const tablist = node.querySelector<HTMLElement>("[role='tablist']");
  const buttonTabs =
    node.querySelectorAll<HTMLButtonElement>(TAB_BUTTON_SELECTOR);
  const tabPanels = node.querySelectorAll<HTMLElement>("[role='tabpanel']");
  const enableHistory = node.dataset.enableHistory === "true";

  tablist.addEventListener("keydown", (e) => {
    switch (e.key) {
      case "ArrowLeft":
        selectPreviousTab();
        break;

      case "ArrowRight":
        selectNextTab();
        break;
    }
  });

  buttonTabs.forEach((tab) => {
    tab.addEventListener(
      "click",
      function (e: Event & { target: HTMLButtonElement }) {
        const nextTabIndex = [...buttonTabs].indexOf(e.target);
        selectTab(nextTabIndex);
      }
    );
  });

  function selectPreviousTab() {
    const activeTab = node.querySelector<HTMLButtonElement>(
      `${TAB_BUTTON_SELECTOR}[aria-selected="true"]`
    );
    if (!activeTab) return;
    const activeTabIndex = [...buttonTabs].indexOf(activeTab);

    if (activeTabIndex > 0) {
      selectTab(activeTabIndex - 1);
    } else {
      selectTab(buttonTabs.length - 1);
    }
  }

  function selectNextTab() {
    const activeTab = node.querySelector<HTMLButtonElement>(
      `${TAB_BUTTON_SELECTOR}[aria-selected="true"]`
    );
    if (!activeTab) return;
    const activeTabIndex = [...buttonTabs].indexOf(activeTab);

    if (activeTabIndex < buttonTabs.length - 1) {
      selectTab(activeTabIndex + 1);
    } else {
      selectTab(0);
    }
  }

  function selectTab(index: number, skipPush = false) {
    buttonTabs.forEach((tab) => {
      tab.setAttribute("aria-selected", "false");
      tab.setAttribute("tabindex", "-1");
    });

    const selectedTab = buttonTabs[index];
    selectedTab.setAttribute("aria-selected", "true");
    selectedTab.setAttribute("tabindex", "0");
    selectedTab.focus();

    const pathname = selectedTab.dataset.pathname;
    if (pathname && !skipPush && enableHistory) {
      window.history.pushState({}, "", pathname);
    }

    tabPanels.forEach((tabPanel) => {
      tabPanel.classList.add("tw-hidden");
    });

    const nextTabPanel = node.querySelector(
      "#" + selectedTab.getAttribute("aria-controls")
    );
    nextTabPanel.classList.remove("tw-hidden");

    window.dispatchEvent(
      new CustomEvent(TAB_SELECTED, {
        detail: {
          tab: selectedTab,
        },
      })
    );
  }

  const handleTabHistory = () => {
    const previousTabIndex = [...buttonTabs].findIndex((buttonElement) => {
      const pathname = window.location.pathname + window.location.hash;
      return buttonElement.dataset.pathname === pathname;
    });

    if (previousTabIndex > -1) {
      selectTab(previousTabIndex, true);
    }
  };

  if (enableHistory) {
    window.addEventListener("popstate", handleTabHistory);
  }

  return () => {
    if (enableHistory) {
      window.removeEventListener("popstate", handleTabHistory);
    }
  };
});
